import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

export default function Loading({ color = 'primary', title = null, titleProps = {}, ...props }) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%" {...props}>
      <CircularProgress color={color} />
      {Boolean(title) && (
        <Box p={2} ml={1} {...titleProps}>
          {title}
        </Box>
      )}
    </Box>
  );
}
